module.exports = __webpack_public_path__ + "img/welcome_forum.f0719bdc.svg";